import React from "react";
import {Modal} from "antd";
import {WarningOutlined} from "@ant-design/icons";
import dashboard from "../../../../resources/dashboard";

const CheckoutConfirmationModal: React.FC<{
    open: boolean;
    onCancel: () => void;
    onOk: () => void;
    snapshot: any | null;
}> = ({open, onCancel, onOk, snapshot}) => {
    const resources = dashboard.attendanceWidget.checkoutModal;

    const ModalTitle: React.FC = () => (
        <span className="hrms-checkout-modal-title">
        <WarningOutlined/>
            {resources.title}
    </span>
    );

    return (
        <Modal
            title={<ModalTitle/>}
            open={open}
            onOk={()=>{onOk();onCancel();}}
            onCancel={onCancel}
            okText={resources.checkOutButtonText}
            cancelText={resources.cancelButtonText}
            className="hrms-app hrms-checkout-modal"
        >
            <div className="hrms-checkout-modal__content">
                    <span className="hrms-checkout-modal__heading">
                        {resources.message}
                    </span>
                <div className="hrms-checkout-modal__status">
                        <span className="checkout-modal__status-item">
                              {resources.checkInLabel}: {snapshot?.time}
                        </span>
                    <span className="hrms-checkout-modal__status-item">
                              {resources.durationLabel}: {snapshot?.duration}
                        </span>
                </div>
            </div>
        </Modal>)
}

export default CheckoutConfirmationModal;
